import React from 'react';

/**
 * Quick-facts strip rendered just under the hero on programmatic service pages.
 * Surfaces per-page trust data (price, turnaround, arrival, warranty) that was
 * previously only emitted in JSON-LD and never shown to the customer.
 *
 * Props:
 *   facts: [{ icon, value, label }]  — values supplied by the caller
 *          (price comes from the pricing util; never hardcoded here).
 */
const QuickFactsPanel = ({ facts }) => {
  if (!facts || !facts.length) return null;
  return (
    <div className="rr-container">
      <div className="rr-quickfacts">
        {facts.map((f, i) => (
          <div key={i} className="rr-quickfacts__item">
            <span className="rr-quickfacts__icon" aria-hidden="true">{f.icon}</span>
            <span className="rr-quickfacts__value">{f.value}</span>
            <span className="rr-quickfacts__label">{f.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickFactsPanel;
